<script>
  import { onMount } from "svelte";

  let status = $state("loading");
  let error = $state("");
  let lastChecked = $state("");
  let { wrapperClass = "" } = $props();

  let isOperational = $derived(status === "All Systems Operational");

  async function checkStatus() {
    try {
      const response = await fetch("https://status.openai.com/api/v2/status.json");
      const data = await response.json();
      // Show only major incidents
      if (data.status?.indicator === "major" || data.status?.indicator === "critical") {
        status = data.status?.description || "Unknown";
      }
      lastChecked = new Date().toLocaleTimeString();
      error = "";
    } catch (err) {
      error = "Unable to fetch OpenAI status";
      console.error("Error fetching OpenAI status:", err);
    }
  }

  onMount(() => {
    checkStatus();
    const interval = setInterval(checkStatus, 5 * 60 * 1000);

    return () => clearInterval(interval);
  });
</script>

{#if error && status !== "loading"}{:else if !isOperational && status !== "loading"}
  <div class={wrapperClass}>
    <div class="flex items-center gap-2 rounded-base border border-red-200 bg-red-50 px-2 py-1">
      <div class="relative">
        <div class="h-2 w-2 animate-pulse rounded-full bg-red-500"></div>
      </div>
      <!-- <div class="flex flex-row items-center justify-center gap-2"> -->
      <span class="text-xs font-medium text-red-700">{status}</span>

      <!-- </div> -->
      {#if lastChecked}
        <span class="ml-auto pt-0.5 text-2xs font-medium text-red-500">{lastChecked}</span>
      {/if}
    </div>
  </div>
{/if}
